import React from 'react';
import cc from 'classcat';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".react-fake-input_1-3-0_co-input {\n  --input-background-color: var(--white);\n  --input-color: var(--var-gray-800);\n  --input-border-color: var(--gray-400);\n  --input-hover-border-color: var(--gray-500);\n  --input-focus-border-color: var(--primary-500);\n  box-sizing: border-box;\n  width: 100%;\n  height: var(--input-height);\n  padding: 0 8px;\n  border: 2px solid var(--input-border-color);\n  border-radius: 4px;\n  outline: none;\n  color: var(--input-color);\n  background-color: var(--input-background-color);\n  font-weight: 400;\n  font-family: var(--font-family);\n  transition: border 0.2s ease;\n  touch-action: manipulation;\n}\n.react-fake-input_1-3-0_co-input:not([disabled]):not([data-disabled]):not([data-co-disabled])[data-co-hover], .react-fake-input_1-3-0_co-input:not([disabled]):not([data-disabled]):not([data-co-disabled]):hover {\n  border-color: var(--input-hover-border-color);\n}\n.react-fake-input_1-3-0_co-input:not([disabled]):not([data-disabled]):not([data-co-disabled])[data-co-focus], .react-fake-input_1-3-0_co-input:not([disabled]):not([data-disabled]):not([data-co-disabled])[data-co-focus][data-co-hover], .react-fake-input_1-3-0_co-input:not([disabled]):not([data-disabled]):not([data-co-disabled])[data-co-focus]:hover, .react-fake-input_1-3-0_co-input:not([disabled]):not([data-disabled]):not([data-co-disabled]):focus, .react-fake-input_1-3-0_co-input:not([disabled]):not([data-disabled]):not([data-co-disabled]):focus[data-co-hover], .react-fake-input_1-3-0_co-input:not([disabled]):not([data-disabled]):not([data-co-disabled]):focus:hover, .react-fake-input_1-3-0_co-input:not([disabled]):not([data-disabled]):not([data-co-disabled]):focus-within, .react-fake-input_1-3-0_co-input:not([disabled]):not([data-disabled]):not([data-co-disabled]):focus-within[data-co-hover], .react-fake-input_1-3-0_co-input:not([disabled]):not([data-disabled]):not([data-co-disabled]):focus-within:hover {\n  border-color: var(--input-focus-border-color);\n}\n\n.react-fake-input_1-3-0_co-input.react-fake-input_1-3-0_co-input--small {\n  --input-height: 32px;\n  font-size: 13px;\n}\n.react-fake-input_1-3-0_co-input.react-fake-input_1-3-0_co-input--medium, .react-fake-input_1-3-0_co-input {\n  --input-height: 40px;\n  font-size: 14px;\n}\n.react-fake-input_1-3-0_co-input.react-fake-input_1-3-0_co-input--error {\n  --input-border-color: var(--error-700);\n  --input-hover-border-color: var(--error-500);\n  --input-focus-border-color: var(--error-500);\n}\n.react-fake-input_1-3-0_co-input.react-fake-input_1-3-0_co-input--warning {\n  --input-border-color: var(--warning-700);\n  --input-hover-border-color: var(--warning-500);\n  --input-focus-border-color: var(--warning-500);\n}\n.react-fake-input_1-3-0_co-input.react-fake-input_1-3-0_co-input--unstyled {\n  height: 100%;\n  padding: 0;\n  border: none;\n  border-radius: 0;\n  background-color: transparent;\n}\n.react-fake-input_1-3-0_co-input.react-fake-input_1-3-0_co-input--wrap {\n  height: unset;\n  min-height: var(--input-height);\n}\n.react-fake-input_1-3-0_co-input.react-fake-input_1-3-0_co-input--clickable {\n  cursor: pointer;\n}\n.react-fake-input_1-3-0_co-input.react-fake-input_1-3-0_co-input--align-left, .react-fake-input_1-3-0_co-input {\n  text-align: left;\n}\n.react-fake-input_1-3-0_co-input.react-fake-input_1-3-0_co-input--align-center {\n  text-align: center;\n}\n.react-fake-input_1-3-0_co-input.react-fake-input_1-3-0_co-input--align-right {\n  text-align: right;\n}\n.react-fake-input_1-3-0_co-input[disabled], .react-fake-input_1-3-0_co-input[readonly], .react-fake-input_1-3-0_co-input[data-co-disabled], .react-fake-input_1-3-0_co-input[data-co-readonly], .react-fake-input_1-3-0_co-input[data-disabled], .react-fake-input_1-3-0_co-input[data-readonly] {\n  --input-background-color: var(--gray-200);\n  --input-color: var(--gray-500);\n  --input-border-color: var(--gray-300);\n}\n.react-fake-input_1-3-0_co-input[disabled], .react-fake-input_1-3-0_co-input[data-co-disabled], .react-fake-input_1-3-0_co-input[data-disabled] {\n  pointer-events: none;\n}\n.react-fake-input_1-3-0_co-input[type=number] {\n  appearance: textfield;\n}\n.react-fake-input_1-3-0_co-input[type=number].react-fake-input_1-3-0_co-input--no-arrows[type=number]::-webkit-inner-spin-button, .react-fake-input_1-3-0_co-input[type=number].react-fake-input_1-3-0_co-input--no-arrows[type=number]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.react-fake-input_1-3-0_co-input::placeholder {\n  color: var(--gray-500);\n  font-weight: 300;\n}";
var styles = {
  "co-input": "react-fake-input_1-3-0_co-input",
  "co-input--small": "react-fake-input_1-3-0_co-input--small",
  "co-input--medium": "react-fake-input_1-3-0_co-input--medium",
  "co-input--error": "react-fake-input_1-3-0_co-input--error",
  "co-input--warning": "react-fake-input_1-3-0_co-input--warning",
  "co-input--unstyled": "react-fake-input_1-3-0_co-input--unstyled",
  "co-input--wrap": "react-fake-input_1-3-0_co-input--wrap",
  "co-input--clickable": "react-fake-input_1-3-0_co-input--clickable",
  "co-input--align-left": "react-fake-input_1-3-0_co-input--align-left",
  "co-input--align-center": "react-fake-input_1-3-0_co-input--align-center",
  "co-input--align-right": "react-fake-input_1-3-0_co-input--align-right",
  "co-input--no-arrows": "react-fake-input_1-3-0_co-input--no-arrows"
};
styleInject(css);

const classModifiers = {
  small: "co-input--small",
  medium: "co-input--medium",
  error: "co-input--error",
  warning: "co-input--warning",
  wrap: "co-input--wrap",
  clickable: "co-input--clickable"
};

const getClassName = modifier => modifier && styles[classModifiers[modifier]];

const FakeInput = ({
  className = "",
  forwardedRef,
  disabled,
  readOnly,
  size = "medium",
  variation,
  wrap,
  ...props
}) => {
  const classStyles = cc([styles["co-input"], getClassName(variation), getClassName(size), getClassName(wrap ? "wrap" : undefined), getClassName(props.onClick ? "clickable" : undefined), className]);
  return React.createElement("div", _extends({
    className: classStyles,
    ref: forwardedRef,
    "data-co-disabled": disabled || undefined,
    "data-co-readonly": readOnly || undefined,
    "aria-disabled": disabled || undefined
  }, props, {
    "data-co-name": "FakeInput",
    "data-co-version": "1.3.0",
    "data-co-project": "cobalt"
  }));
};

export default FakeInput;
